import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { m } from 'motion/react';
import { useAuthStore } from '@/stores/auth';

/**
 * Guarda de rota: 'boot' = splash enquanto o refresh inicial roda;
 * 'guest' = manda pro login lembrando de onde veio; 'authed' = renderiza.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();

  if (status === 'boot') {
    return (
      <div className="grid min-h-dvh place-items-center bg-canvas">
        <m.div
          animate={{ scale: [1, 1.08, 1] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: 'easeInOut' }}
          className="grid size-14 place-items-center rounded-2xl bg-primary text-xl font-bold text-white"
          aria-label="Carregando"
        >
          L
        </m.div>
      </div>
    );
  }

  if (status === 'guest') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
